import { RevisionHistoryDialogCtrl } from '~src/revisionHistory/controllers/RevisionHistoryDialogCtrl';
import { IActionContext } from '~src/ts/helpers/ActionContext';
import { Set } from '~src/ts/models/Set';
import { FlowRevision } from '../serverApi/types/FlowRevision';
import { IActionButton } from '~src/commonInfra/contentActions/ActionPanelInterfaces';
import { DeleteRevisionAction } from '~src/revisionHistory/services/DeleteRevisionAction';
import { RevisionActions } from '~src/revisionHistory/services/RevisionActions';
import {
  RevisionHistoryActionButton,
  RevisionHistoryActionContext,
} from '~src/revisionHistory/interfaces/RevisionHistoryActionContext';

export namespace RevisionActionFlow {
  export function getFlowRevisionActionButtons(): RevisionHistoryActionButton<FlowRevision>[] {
    return [
      deleteFlowRevisionAction(),
      RevisionActions.downloadContentRevisionAction()
    ];
  }
  export function getFlowRevisionActionButtonsAngular(): IActionButton<FlowRevision, {}>[] {
    return [
      deleteFlowRevisionActionAngular(),
      RevisionActions.downloadContentRevisionActionAngular()
    ];
  }

  // action button factories
  function deleteFlowRevisionAction(): RevisionHistoryActionButton<FlowRevision> {
    return {
      name: 'delete',
      translate: 'delete_action',
      execute: (context: RevisionHistoryActionContext<FlowRevision>) => {
        DeleteRevisionAction.showDeleteFlowRevisionDialog(context.selectedItem, context);
      }
    };
  }

  function deleteFlowRevisionActionAngular(): IActionButton<FlowRevision, {}> {
    return {
      name: 'delete',
      translate: 'delete_action',
      isAvailable: (items: Set<FlowRevision>) => items.size() === 1,
      execute: (items: Set<FlowRevision>, context: IActionContext) => {
        const scope = <RevisionHistoryDialogCtrl.Scope>context.scope;
        DeleteRevisionAction.showDeleteFlowRevisionDialog(items.first(), context).then(() => scope.refreshContent());
      }
    };
  }
}
